<template>
    <v-form
        :defaultValues="{ search: '' }"
        @submit="$emit('search', $event.search.trim())"
    >
        <template scope="api">
            <v-row align-items="end">
                <v-col xs="7">
                    <v-form-input field="search" label="Поиск по ФИО" />
                </v-col>
                <v-col xs="5">
                    <v-button type="submit" flat primary>
                        найти
                    </v-button>
                </v-col>
            </v-row>
        </template>
    </v-form>
</template>
<script>
export default {
    name: 'form-search',
}
</script>



// WEBPACK FOOTER //
// FormSearch.vue?dc14148c